import React, { Component } from 'react'

import Searchbar from '../../utils/Searchbar'
import SearchPage from '../../search/SearchPage'

class PageSearch extends Component {
    render() {
        return (
            <div>
                <Searchbar placeholder={"Search orders"} component={SearchPage} searchEndpoint={'search/content'} {...this.props} userType="admin" index="permalink" />
            </div>
        )
    }
}

export default PageSearch



// WEBPACK FOOTER //
// ./src/components/admin/pages/PageSearch.js